<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Daftar Profil Kehamilan</h5>
              <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
                    v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div class="table-responsive">

              <table class="table align-middle table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th class="w-25 text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Nama Kehamilan
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center" scope="col">
                      <a href="#" class="link-dark">
                        HPHT
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center" scope="col">
                      <a href="#" class="link-dark">
                        HPL
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Tanggal Kelahiran
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Jenis Persalinan
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Rujukan
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center" scope="col">
                      <a href="#" class="link-dark">
                        Status
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-end" scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(req, idx) in dataList" :key="idx">
                    <th scope="row">{{ idx + 1 }}</th>
                    <td class="text-nowrap">{{ req.profile_kehamilan || '-'}}</td>
                    <td class="text-center">{{req.hpht || '-'}}</td>
                    <td class="text-center">{{req.hpl || '-'}}</td>
                    <td class="text-center">{{req.delivery_date || '-'}}</td>
                    <td class="text-center">
                      <small
                        :class="req.delivery_type == 'Normal' ? 'text-bg-primary' : 'text-bg-secondary'"
                        class="badge fs-1 bg-opacity-75"
                      >{{ req.delivery_type || '-' }}</small>
                    </td>

                    <td class="text-center">{{req.referral_status || '-'}}</td>
                    <td class="text-center">
                      <small
                        :class="req.status == 'Postpartum' ? 'text-bg-success' : 'text-bg-danger'"
                        class="badge fs-1 bg-opacity-75"
                      >{{ req.status }}</small>
                    </td>
                    <td class="text-nowrap text-end">
                      <router-link
                        :to="`/form-maternity?userId=${userId}&id=${req.id}`"
                        class="btn btn-sm btn-outline-primary"
                        title="Ubah"
                      >
                        <i class="ti ti-edit fs-3"></i>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="dataList.length"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import { allMixin } from '@/mixins/allMixin.js'

export default {
	mixins: [allMixin],
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			user_login: JSON.parse(localStorage.getItem('user_login')).data,
			cariTitle: '',
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50]
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDataPayload',
			countDataList: 'location/getcountDataPayload'
		}),
		userId: {
			// getter
			get() {
				return this.$route.query.userId || ''
			}
		}
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getDataPayload', {
					url: `user_pregnancies?userId=${this.userId}`,
					params: {
						profile: this.cariTitle,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
